import { render, staticRenderFns } from "./DiningStandard.vue?vue&type=template&id=01ca9720&scoped=true&"
import script from "./DiningStandard.vue?vue&type=script&lang=js&"
export * from "./DiningStandard.vue?vue&type=script&lang=js&"
import style0 from "./DiningStandard.vue?vue&type=style&index=0&id=01ca9720&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ca9720",
  null
  
)

export default component.exports